import Vue from 'vue';
import VueI18n from 'vue-i18n';
import jobboardI18n from '@muz/jobboard-vue-client/src/i18n';
import { merge } from 'lodash';
import { locales as toolboxLocales } from '@jobstairs/vuetify-toolbox/src';

Vue.use(VueI18n);

function loadLocaleMessages() {
    const locales = require.context(
        './locales',
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i,
    );
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

const messages = merge(
    jobboardI18n.messages,
    toolboxLocales.messages,
    loadLocaleMessages(),
);

export default new VueI18n({
    locale: new Intl.Locale(navigator.language).language || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    silentTranslationWarn: process.env.NODE_ENV !== 'production',
    messages,
});
